var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicenseicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15547 15.9717L3.21252 20.0564C3.05926 20.4914 3.52399 20.8927 3.94916 20.6896L5.93661 19.7373C6.26785 19.5778 6.66831 19.7132 6.83145 20.037L7.8054 21.9803C8.01305 22.396 8.63103 22.3573 8.7843 21.9223L10.3911 18.785H10.7915L12.3983 21.9223C12.5515 22.3573 13.1695 22.396 13.3772 21.9803L14.3511 20.037C14.5143 19.7132 14.9147 19.5778 15.246 19.7373L17.2334 20.6896C17.6586 20.8927 18.1233 20.4914 17.9701 20.0564L16.0271 15.9717",
    stroke: "#F0F0F0",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5888 13.3902C12.2653 13.3902 13.6243 12.0614 13.6243 10.4222C13.6243 8.78295 12.2653 7.4541 10.5888 7.4541C8.91229 7.4541 7.55322 8.78295 7.55322 10.4222C7.55322 12.0614 8.91229 13.3902 10.5888 13.3902Z",
    stroke: "#F0F0F0",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6308 12.1675C17.4564 13.2745 16.5467 14.8117 15.1575 14.6619C13.8474 14.5217 12.5966 15.2274 12.0676 16.4069C11.504 17.6589 9.6846 17.6589 9.121 16.4069C8.58706 15.2274 7.33625 14.5217 6.03106 14.6619C4.63688 14.8117 3.7272 13.2697 4.55778 12.1675C5.33397 11.1282 5.33397 9.71671 4.55778 8.67741C3.73215 7.57043 4.64182 6.03323 6.03106 6.18308C7.34119 6.32327 8.592 5.61751 9.121 4.43802C9.6846 3.18602 11.504 3.18602 12.0676 4.43802C12.6015 5.61751 13.8523 6.32327 15.1575 6.18308C16.5517 6.03323 17.4614 7.57527 16.6308 8.67741C15.8546 9.71671 15.8546 11.1282 16.6308 12.1675Z",
    stroke: "#F0F0F0",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseicon);
export default __webpack_public_path__ + "static/media/licenseicon.c45dbc074ee01c1a6ee4dc86c347b4c6.svg";
export { ForwardRef as ReactComponent };